/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import { Link, NavLink } from 'react-router-dom';
import { createFragmentContainer, graphql } from 'react-relay';

import { Button } from './ui/button';
import { Sheet, SheetContent } from './ui/sheet';
import { Home, Users, Star, DollarSign, Plus } from 'lucide-react';
import { cn } from '../lib/utils';

const drawerWidth = 240;

class Channels extends React.Component {
  constructor(...args) {
    super(...args);
    this.channelList = this.channelList.bind(this);
  }

  channelList(allChannels) {
    return (
      <>
        {allChannels.map(edge => {
          return (
            <NavLink
              key={edge.node.id}
              to={`/channels/${edge.node.id}`}
              end
              onClick={this.props.drawerClose}
              className={({ isActive }) =>
                cn(
                  'flex items-center px-3 py-2 text-sm transition-colors duration-150 rounded-md mx-2 my-0.5',
                  isActive 
                    ? 'bg-primary/10 text-primary font-medium' 
                    : 'text-gray-700 hover:bg-gray-100',
                )
              }
            >
              {edge.node.name}
            </NavLink>
          );
        })}
      </>
    );
  }

  render() {
    const drawer = (
      <div className="h-full flex flex-col">
        <div className="bg-primary h-14 border-r-0 md:hidden" />
        <nav className="bg-white p-2 flex-1 overflow-y-auto">
          <NavLink
            to="/"
            end
            onClick={this.props.drawerClose}
            className={({ isActive }) =>
              cn(
                'flex items-center px-3 py-2 text-sm hover:bg-gray-100',
                isActive && 'bg-gray-200',
              )
            }
          >
            <Home className="h-5 w-5 mr-2 text-primary" />
            Home
          </NavLink>
          {this.props.viewer.role !== 'limited' && (
            <NavLink
              to="/team"
              end
              onClick={this.props.drawerClose}
              className={({ isActive }) =>
                cn(
                  'flex items-center px-3 py-2 text-sm transition-colors duration-150 rounded-md mx-2 my-0.5',
                  isActive 
                    ? 'bg-primary/10 text-primary font-medium' 
                    : 'text-gray-700 hover:bg-gray-100',
                )
              }
            >
              <Users className="h-5 w-5 mr-2 text-primary" />
              Team
            </NavLink>
          )}
          {this.props.viewer.subscribed === 'limited' ? (
            <NavLink
              to="/subscribe"
              end
              onClick={this.props.drawerClose}
              className={({ isActive }) =>
                cn(
                  'flex items-center px-3 py-2 text-sm transition-colors duration-150 rounded-md mx-2 my-0.5',
                  isActive 
                    ? 'bg-primary/10 text-primary font-medium' 
                    : 'text-gray-700 hover:bg-gray-100',
                )
              }
            >
              <DollarSign className="h-5 w-5 mr-2 text-primary" />
              Subscribe
            </NavLink>
          ) : null}
          <div className="flex items-center px-3 py-2 mx-2 my-2 border-b border-gray-200 pb-3">
            <Star className="h-4 w-4 mr-2 text-primary" />
            <span className="flex-1 text-xs font-semibold text-gray-500 uppercase tracking-wider">Channels</span>
            <Link to="/channel/create">
              <Button variant="ghost" size="icon" aria-label="Add" className="h-7 w-7 hover:bg-primary/10">
                <Plus className="h-4 w-4 text-primary" />
              </Button>
            </Link>
          </div>
          {this.channelList(this.props.viewer.channels.edges)}
        </nav>
      </div>
    );

    return (
      <div>
        <div className="md:hidden">
          <Sheet
            open={this.props.mobileOpen}
            onOpenChange={this.props.drawerToggle}
          >
            <SheetContent side="left" className="w-[240px] p-0 bg-gray-100">
              {drawer}
            </SheetContent>
          </Sheet>
        </div>
        <div className="hidden md:block fixed left-0 top-14 h-[calc(100vh-3.5rem)] w-[240px] bg-gray-100 border-r z-40">
          {drawer}
        </div>
      </div>
    );
  }
}

Channels = createFragmentContainer(Channels, {
  viewer: graphql`
    fragment Channels_viewer on User {
      subscribed
      role
      channels(first: 100) @connection(key: "Channels_channels") {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  `,
});

export default Channels;
